export default __webpack_public_path__ + "static/media/4336.03b1735c.png";